// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8bf3c546","239":"82918ce5","453":"879ea34b","455":"1635c879"}[chunkId] + ".chunk.js";
};